import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/tags',
    name: 'tags',
    props: true,
    meta: {
      title: 'Tags'
    },
    component: () => import('@/views/tags/TagListView.vue')
  },
  {
    path: '/tags/create',
    name: 'tag-create',
    props: true,
    meta: {
      title: 'Create Tag'
    },
    component: () => import('@/views/tags/TagCreateView.vue')
  },
  {
    path: '/tags/:id',
    name: 'tag-edit',
    props: true,
    meta: {
      title: 'Edit Tag'
    },
    component: () => import('@/views/tags/TagEditView.vue')
  }
]

export default routes
